import React from "react";
import "./CompetitiveSites.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { adaptiveIconStyle } from "../../utils/theme";

class CompetitiveSites extends React.Component {
  render() {
    return (
      <div className="competitive-sites-main-div">
        <ul className="dev-icons">
          {this.props.logos.map((logo) => {
            const badge = (
              <>
                    {logo.iconifyClassname ? (
                      <span
                        className="iconify"
                        data-icon={logo.iconifyClassname}
                        style={adaptiveIconStyle(logo.style)}
                        data-inline="false"
                      ></span>
                    ) : (
                      <span className="site-badge" style={adaptiveIconStyle(logo.style)}>
                        {logo.badgeText || logo.siteName}
                      </span>
                    )}
              </>
            );
            return (
              <OverlayTrigger
                key={logo.siteName}
                placement={"top"}
                style={{ marginBottom: "5px" }}
                overlay={
                  <Tooltip id={`tooltip-top`}>
                    <strong>{logo.siteName}</strong>
                  </Tooltip>
                }
              >
                <li className="competitive-sites-inline" name={logo.siteName}>
                  {logo.profileLink ? (
                    <a
                      href={logo.profileLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {badge}
                    </a>
                  ) : (
                    badge
                  )}
                </li>
              </OverlayTrigger>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default CompetitiveSites;
